import React, {useState} from 'react';
import UrlOpener from "./url-opener";
import {PlusCircleIcon} from "@heroicons/react/24/solid";
import DesignCardList from "../../design/components/dashboard/design-card-list";

const UtilitiesDashboard = () => {

    return (
        <>

            <div className="page-container-background design-dashboard-container">

                <div className="items-center justify-start p-8 mb-28 w-full">
                    <div className="flex justify-start items-center m-2 pb-2 -mt-1">
                        <div className="text-xl">
                            Utilities
                        </div>
                    </div>


                    <div className="items-center justify-start w-full pb-16 mr-8 my-8">
                        <UrlOpener/>
                    </div>

                </div>

            </div>

        </>
    )
}

export default UtilitiesDashboard
